import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { API_BASE_URL } from "../config";
import "../styles/Loyalty.css";

const Loyalty = () => {
  const { user } = useAuth();
  const [compras, setCompras] = useState(0);
  const [loading, setLoading] = useState(true);

  const totalSellos = 10;
  const sellos = Array.from({ length: totalSellos }, (_, i) => i < compras);

  useEffect(() => {
    const fetchLoyalty = async () => {
      if (!user) return;

      try {
        const res = await fetch(`${API_BASE_URL}/loyalty/me`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });

        const data = await res.json();
        setCompras(data.purchases || 0);
      } catch (error) {
        console.error("Error al obtener datos de lealtad", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLoyalty();
  }, [user]);

  if (!user) {
    return (
      <div className="loyalty-container">
        <h1>Club de Lealtad Bibas</h1>
        <p>Inicia sesión para ver tu progreso:</p>
        <Link className="loyalty-login-btn" to="/login">Iniciar sesión</Link>
      </div>
    );
  }

  if (loading) return <p className="loyalty-container">Cargando...</p>;

  return (
    <div className="loyalty-container">
      <h1>Club de Lealtad Bibas</h1>
      <p className="loyalty-description">
        ¡Por cada compra recibes un sello! Al completar los 10 sellos, obtienes un premio exclusivo.
      </p>

      <div className="stamps-card">
        {sellos.map((marcado, index) => (
          <div
            key={index}
            className={`stamp ${marcado ? "active" : ""}`}
          >
            {marcado ? "✅" : index + 1}
          </div>
        ))}
      </div>

      {compras >= totalSellos && (
        <div className="reward-section">
          <h2>🎉 ¡Felicidades!</h2>
          <p>Has completado tu tarjeta. Reclama tu premio en tu próxima visita.</p>
        </div>
      )}
    </div>
  );
};

export default Loyalty;
